import React, { useState, useEffect } from "react"
import _get from "lodash/get"
import { NumericFormat } from "react-number-format"
import QuantitySelector from "@/components/cart/QuantitySelector"
import noImage from "@/public/images/image-missing.png"
import installImage from "@/public/icons/installation-service.svg"
import { checkStock } from "@/utils/helper"
import { removeCartItem, breakBundleItem } from "@/components/cart/cartHelper"
import styles from "@/components/PreviewCart/v1/index.module.scss"

export default function InstallationServiceCart({
  data = {},
  currencySign,
  i18n,
  productQuantity,
  onQuantityChange,
  loading,
  productData,
  handleExceed,
  setLoading = () => {},
  checkoutMode,
}) {
  const [quantity, setQuantity] = useState()
  const { isBundleChildItem, quantity: bundleInstallationQty } = data

  useEffect(() => {
    setQuantity(
      isBundleChildItem
        ? bundleInstallationQty
        : productData?.custom?.fields?.associatedServiceQty
    )
  }, [productData, data])

  const handleChange = async qty => {
    setQuantity(qty)
    await onQuantityChange(
      data?.sku,
      qty,
      false,
      checkStock(data.backOrder, data.category),
      () => {},
      productData,
      data.id
    )
  }

  const MRPPriceObj = data?.prices?.find(price => !price.customerGroup)
  const MRPPrice = Number((MRPPriceObj?.value?.centAmount ?? 0) / 100).toFixed(
    2
  )
  const MRPDiscount = Number(
    ((Number(MRPPrice) - Number(data.unitPrice)) / Number(MRPPrice)) * 100
  ).toFixed()
  const installSku = data?.custom?.fields?.isBundleChildItem
    ? data.custom.fields.parentBundleSku
    : data.custom.fields.associatedProduct ?? data.sku
  return (
    <div className={styles.installationCartWrapper}>
      <div className="installation-cart-item">
        <img
          onError={e => {
            e.target.src = noImage.src
          }}
          src={installImage.src}
          alt=""
          className="installation-cart-item__image"
        />
        <div className="installation-cart-item__details">
          <p className="installation-cart-item__name">
            {" "}
            Installation Service for SKU <span>{installSku}</span>
          </p>
          <p className="installation-cart-item__finish">{data.desc}</p>
          <div className="installation-cart-item__footer">
            <div className="installation-cart-item__qty">
              {!checkoutMode && (
                <QuantitySelector
                  size="small"
                  value={quantity}
                  onChange={handleChange}
                  loading={loading}
                  productQuantity={productQuantity}
                  handleExceed={handleExceed}
                  setQuantity={setQuantity}
                />
              )}
              {checkoutMode && (
                <span
                  className="preview-cart-item__qty-label"
                  data-testid="prodQuantity"
                >{`${i18n.qtyLabel}: ${data.quantity}`}</span>
              )}
            </div>
            <div className="installation-cart-item__price-details">
              <p className="installation-cart-item__price">
                <NumericFormat
                  className="total-price"
                  aria-description={i18n.total}
                  value={
                    data.discountPrice > 0
                      ? data.discountPrice *
                        Number(
                          productData?.custom?.fields?.associatedServiceQty ??
                            data.quantity ??
                            1
                        )
                      : data.unitPrice *
                        (productData?.custom?.fields?.associatedServiceQty ??
                          data.quantity ??
                          1)
                  }
                  displayType={"text"}
                  thousandSeparator={true}
                  prefix={currencySign}
                  decimalScale={2}
                  fixedDecimalScale={true}
                />
              </p>
              {data.discountPrice > 0 && data.discountPercent > 0 && (
                <div className="preview-cart-item__discount-container">
                  <p className="preview-cart-item__offPercent">
                    {data.discountPercent
                      ? `${data.discountPercent}${i18n.discountPercentage}`
                      : `${currencySign}${data.discountAmount} ${i18n.off}`}
                  </p>
                  <p className="preview-cart-item__discount">
                    <NumericFormat
                      value={
                        data.unitPrice *
                        (productData?.custom?.fields?.associatedServiceQty ??
                          data.quantity ??
                          1)
                      }
                      displayType={"text"}
                      aria-description={i18n.strikedPrice}
                      thousandSeparator={true}
                      prefix={currencySign}
                      decimalScale={2}
                      fixedDecimalScale={true}
                      thousandsGroupStyle={"lakh"}
                    />
                  </p>
                </div>
              )}
              {/* {MRPPrice &&
                MRPPrice !== data.unitPrice &&
                MRPPrice !== data.discountPrice && (
                  <div className="preview-cart-item__discount-container">
                    <p className="preview-cart-item__offPercent">
                      {MRPDiscount
                        ? `${MRPDiscount}${i18n.discountPercentage}`
                        : `${currencySign}${data.discountAmount} ${i18n.off}`}
                    </p>
                    <p className="preview-cart-item__discount">
                      <span>MRP: </span>
                      <NumericFormat
                        value={MRPPrice * data.quantity}
                        displayType={"text"}
                        aria-description={i18n.strikedPrice}
                        thousandSeparator={true}
                        prefix={currencySign}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        thousandsGroupStyle={"lakh"}
                      />
                    </p>
                  </div>
                )} */}
            </div>
          </div>
          {!checkoutMode && (
            <div
              className={`installation-cart-item__remove ${
                loading ? "--loading" : ""
              }`}
            >
              <span
                role="button"
                tabIndex="0"
                aria-label={`${data.name} ${i18n.remove}`}
                onClick={() =>
                  isBundleChildItem
                    ? breakBundleItem(data.id)
                    : removeCartItem({
                        ...data,
                        quantity:
                          productData?.custom?.fields?.associatedServiceQty,
                        productData,
                      })
                }
              >
                {i18n.remove}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
